import { render, staticRenderFns } from "./HotChapter.vue?vue&type=template&id=87765862&"
import script from "./HotChapter.vue?vue&type=script&lang=ts&"
export * from "./HotChapter.vue?vue&type=script&lang=ts&"
import style0 from "./HotChapter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports